import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, " Usuários do Sistema ", -1)
const _hoisted_3 = {
  key: 0,
  class: "pt-3 pb-2 mb-3 border-bottom"
}
const _hoisted_4 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_5 = { class: "table-responsive mb-4" }
const _hoisted_6 = { class: "table table-striped table-sm" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Ações "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " # "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Nome "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Email "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Login "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Status ")
  ])
], -1)
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  class: "d-flex justify-content-center mt-4 mb-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: $setup.isLoading,
        "can-cancel": true,
        "on-cancel": $setup.onCancel,
        "is-full-page": $setup.dados.fullPage
      }, null, 8, ["active", "on-cancel", "is-full-page"])
    ]),
    _hoisted_2,
    ($setup.acesso.btnInsert)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: `/newuser/${$setup.route.params.t}/${$setup.route.params.id}/${$setup.route.params.perfil}`,
            class: "btn btn-sm btn-outline-secondary",
            title: "Novo Usuário local"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: "file" })
            ]),
            _: 1
          }, 8, ["to"]),
          _createTextVNode(" Total Registro: " + _toDisplayString($setup.dados.totalreg), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("input", {
        class: "form-control",
        placeholder: "Procurar Nome ou Email",
        onKeyup: _cache[0] || (_cache[0] = ($event: any) => ($setup.search($event.target.value)))
      }, null, 32)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredTable, (user) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: user.id
            }, [
              _createElementVNode("td", null, [
                ($setup.acesso.btnAlter)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: `/users/${$setup.route.params.t}/${$setup.route.params.id}/${$setup.route.params.perfil}/${user.id}/edit`,
                      class: "btn btn-sm btn-outline-secondary",
                      title: "Alterar Usuário"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "pencil-alt" })
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true),
                ($setup.acesso.btnDelete)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: "javascript:void(0)",
                      class: "btn btn-sm btn-outline-secondary",
                      title: "Ativar Usuário",
                      onClick: ($event: any) => ($setup.ativar(user.id))
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "thumbs-up" })
                    ], 8, _hoisted_8))
                  : _createCommentVNode("", true),
                ($setup.acesso.btnDelete)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      href: "javascript:void(0)",
                      class: "btn btn-sm btn-outline-secondary",
                      title: "Inativar Usuário",
                      onClick: ($event: any) => ($setup.inativar(user.id))
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "thumbs-down" })
                    ], 8, _hoisted_9))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", null, _toDisplayString(user.id), 1),
              _createElementVNode("td", null, _toDisplayString(user.first_name) + " " + _toDisplayString(user.last_name), 1),
              _createElementVNode("td", null, _toDisplayString(user.email), 1),
              _createElementVNode("td", null, _toDisplayString(user.username), 1),
              _createElementVNode("td", null, [
                _createElementVNode("span", {
                  class: _normalizeClass(user.status==='1' ? 'badge bg-primary d-block' : 'badge bg-danger d-block' )
                }, _toDisplayString(user.status==='1' ? ' Ativo ' : 'Inativo'), 3)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    ($setup.page < $setup.lastPage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-outline-secondary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.loadMore && $setup.loadMore(...args)))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "plus-circle" })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}